module.exports = ".delete-approval-rule {\n    color: #8e8fa6;\n    cursor: pointer;\n    text-decoration: none;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/organization/components/approvals/approved-rules/approved-rules.component.css
// module id = ./src/app/organization/components/approvals/approved-rules/approved-rules.component.css
// module chunks = main